import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AlertExclamationCircleFilledIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9226 22.719C18.4455 22.719 22.9226 18.2419 22.9226 12.719C22.9226 7.19616 18.4455 2.71901 12.9226 2.71901C7.39976 2.71901 2.92261 7.19616 2.92261 12.719C2.92261 18.2419 7.39976 22.719 12.9226 22.719ZM12.9226 7.71901C13.4749 7.71901 13.9226 8.16672 13.9226 8.71901V12.719C13.9226 13.2713 13.4749 13.719 12.9226 13.719C12.3703 13.719 11.9226 13.2713 11.9226 12.719V8.71901C11.9226 8.16672 12.3703 7.71901 12.9226 7.71901ZM13.9226 16.719C13.9226 17.2713 13.4749 17.719 12.9226 17.719C12.3703 17.719 11.9226 17.2713 11.9226 16.719C11.9226 16.1667 12.3703 15.719 12.9226 15.719C13.4749 15.719 13.9226 16.1667 13.9226 16.719Z"
            />
        </SvgIcon>
    );
};

export default AlertExclamationCircleFilledIcon;
